export default __webpack_public_path__ + "static/media/img8.576b9427.jpg";